import React from 'react';

import { TextActivityCard } from '@adsk/alloy-react-activity-log';

import { ACTIVITY_VARIANTS } from '../constants';
import { useTranslation } from './i18n';

const DocsActivityCard = React.forwardRef(
  ({ entity, variant, ...rest }, ref) => {
    const { t } = useTranslation();
    return (
      <TextActivityCard
        {...rest}
        ref={ref}
        title={
          variant === ACTIVITY_VARIANTS.REMOVED
            ? t('FILE_ACTIVITY_TITLE_REMOVED')
            : t('FILE_ACTIVITY_TITLE_ADDED')
        }
        text={entity.name}
      />
    );
  },
);

DocsActivityCard.displayName = 'DocsActivityCard';

export default DocsActivityCard;
